class NumberHelper {
  public static isSafeDivider(value: number): boolean {
    return value != null && !Number.isNaN(value) && value !== 0;
  }
}

export default NumberHelper;
